import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body1Strong, Button, Caption1, makeStyles, mergeClasses, Spinner, tokens, } from '@fluentui/react-components';
import { ArrowSyncRegular, ErrorCircleRegular } from '@fluentui/react-icons';
const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: tokens.spacingVerticalS,
        padding: `${tokens.spacingVerticalXXXL} ${tokens.spacingHorizontalXXL}`,
        textAlign: 'center',
        flexGrow: 1,
        minHeight: '200px',
        boxSizing: 'border-box',
    },
    icon: {
        display: 'flex',
        fontSize: '40px',
        color: tokens.colorNeutralForeground3,
        marginBottom: tokens.spacingVerticalXS,
    },
    iconSuccess: { color: tokens.colorPaletteGreenForeground1 },
    iconDanger: { color: tokens.colorPaletteRedForeground1 },
    description: { color: tokens.colorNeutralForeground3, maxWidth: '420px' },
    action: { marginTop: tokens.spacingVerticalS },
});
/** Lista vazia, nada a fazer ou falha: ícone, título e uma ação opcional. */
export function EmptyState({ icon, tone = 'neutral', title, description, action, }) {
    const styles = useStyles();
    return (_jsxs("div", { className: styles.root, children: [icon !== undefined && (_jsx("span", { className: mergeClasses(styles.icon, tone === 'success' && styles.iconSuccess, tone === 'danger' && styles.iconDanger), "aria-hidden": true, children: icon })), _jsx(Body1Strong, { children: title }), description !== undefined && (_jsx(Caption1, { className: styles.description, children: description })), action !== undefined && _jsx("div", { className: styles.action, children: action })] }));
}
/** Falha ao carregar um bloco, com a opção de tentar de novo. */
export function ErrorState({ title, error, onRetry, }) {
    return (_jsx("div", { role: "alert", children: _jsx(EmptyState, { icon: _jsx(ErrorCircleRegular, {}), tone: "danger", title: title, description: error.message, ...(onRetry === undefined
                ? {}
                : {
                    action: (_jsx(Button, { appearance: "primary", icon: _jsx(ArrowSyncRegular, {}), onClick: onRetry, children: "Tentar de novo" })),
                }) }) }));
}
export function LoadingState({ label = 'Carregando...' }) {
    const styles = useStyles();
    return (_jsx("div", { className: styles.root, children: _jsx(Spinner, { size: "medium", label: label }) }));
}
//# sourceMappingURL=StateView.js.map